import firebase from "firebase/compat/app";

export class QueryData {
  constructor(
    public readonly fieldPath: string,
    public readonly operator: firebase.firestore.WhereFilterOp,
    public readonly value: any
  ) {}
}
